import { NewConversation } from './NewConversation'
import { useTw } from '../../../../../utils/Styles'
import { useProfile } from '../../../../../utils/Profile'
import { ConversationMessage } from './ConversationMessage'
import { AuthenticationType } from '../../../../../api/types'
import { useConversationsQuery } from './Conversation.generated'

export function Conversation() {
  const tw = useTw()
  const profile = useProfile()
  const { data } = useConversationsQuery()
  const isGuestOrUnauth = [
    AuthenticationType.Guest,
    AuthenticationType.Unauthenticated,
  ].includes(profile.visitor.type)

  if ((profile.allowGuests || !isGuestOrUnauth) && data?.Conversations) {
    const convo = data?.Conversations?.find((_) => _.done === false)

    if (convo)
      return (
        <div className={tw`flex items-center bg-white shadow-md rounded`}>
          <ConversationMessage
            conversation={convo}
            showMore={data.Conversations.length > 1}
          />
        </div>
      )

    return (
      <div className={tw`flex items-center bg-white shadow-md rounded`}>
        <NewConversation showMore={data.Conversations.length > 0} />
      </div>
    )
  }

  return null
}
